import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { Anchor, Box, Group, Stack, Text, ThemeIcon } from '@mantine/core';
import { IconClockShare } from '@tabler/icons-react';
import { api, TIME_PROPOSALS_QUERY_KEY } from '../../lib/api';
import { TimeProposalCard } from '../../components/timeProposals/TimeProposalCard';

/** Höchstens so viele Vorschläge auf der Startseite — der Rest steht unter „Alle anzeigen". */
const SHOWN = 3;

/**
 * Startseite: Zeitvorschläge, die auf meine Freigabe warten (v1.404.0) — direkt freigeben, bearbeiten
 * oder verwerfen. Nichts anzeigen, wenn nichts wartet.
 */
export function TimeProposalsWidget() {
  const navigate = useNavigate();
  const { data } = useQuery({
    queryKey: [...TIME_PROPOSALS_QUERY_KEY, 'received', 'open'],
    queryFn: () => api.getTimeProposals('received', true),
    refetchInterval: 60_000,
  });
  const proposals = data?.proposals ?? [];
  if (proposals.length === 0) return null;

  return (
    <Box>
      <Group justify="space-between" mb="md">
        <Group gap="xs">
          <ThemeIcon size="sm" color="grape" variant="light" radius="xl">
            <IconClockShare size={14} />
          </ThemeIcon>
          <Text size="sm" c="dimmed" tt="uppercase" fw={500}>
            Zeitvorschläge zum Freigeben ({proposals.length})
          </Text>
        </Group>
        <Anchor size="xs" c="dimmed" onClick={() => navigate('/zeitvorschlaege')}>
          Alle anzeigen →
        </Anchor>
      </Group>
      <Stack gap="sm">
        {proposals.slice(0, SHOWN).map((p) => (
          <TimeProposalCard key={p.id} proposal={p} perspective="received" />
        ))}
      </Stack>
    </Box>
  );
}
